var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXenieNewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 201,
    viewBox: "0 0 568 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1394_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.16 103.149C133.16 103.149 133.132 103.104 133.115 103.081C133.12 103.081 133.12 103.076 133.12 103.064C133.126 103.092 133.149 103.115 133.16 103.144V103.149Z",
    fill: "url(#paint0_linear_1394_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.16 103.149C133.16 103.149 133.132 103.104 133.115 103.081C133.12 103.081 133.12 103.076 133.12 103.064C133.126 103.092 133.149 103.115 133.16 103.144V103.149Z",
    fill: "url(#paint1_linear_1394_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.16 103.149C133.16 103.149 133.132 103.104 133.115 103.081C133.12 103.081 133.12 103.076 133.12 103.064C133.126 103.092 133.149 103.115 133.16 103.144V103.149Z",
    fill: "url(#paint2_linear_1394_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.16 103.149C133.16 103.149 133.132 103.104 133.115 103.081C133.12 103.081 133.12 103.076 133.12 103.064C133.126 103.092 133.149 103.115 133.16 103.144V103.149Z",
    fill: "url(#paint3_linear_1394_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.504 17.9006C162.304 49.8332 151.172 79.2128 133.127 103.06C133.127 103.066 133.127 103.078 133.121 103.078C124.552 114.413 114.404 124.493 103.027 132.992C102.343 133.509 101.647 134.026 100.944 134.524C76.2084 152.364 45.8376 162.877 13.0065 162.877C9.05185 162.877 5.12725 162.72 1.24463 162.426V120.504C5.10324 120.925 9.02784 121.135 13.0065 121.135C38.4025 121.135 61.7642 112.431 80.289 97.852C81.2793 97.0651 82.2634 96.2602 83.2235 95.4493C93.0291 87.1659 101.346 77.1824 107.725 65.9497C111.104 60.0028 113.942 53.7016 116.163 47.13V47.112C119.295 37.8614 121.222 28.0763 121.756 17.9066H163.504V17.9006Z",
    fill: "url(#paint4_linear_1394_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.414 57.6853C94.2592 67.4285 87.5201 76.1924 79.533 83.641C77.2767 85.7494 74.9243 87.7496 72.4818 89.6298C53.8009 71.8614 28.8249 60.6587 1.24463 59.7216V17.9558C27.9848 18.6106 52.9967 26.2453 74.5342 39.1059C83.4695 44.44 91.7989 50.6753 99.414 57.6853Z",
    fill: "url(#paint5_linear_1394_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.862 136.766V183.692C160.321 180.953 154.014 177.757 147.989 174.159C133.551 165.539 120.685 154.576 109.907 141.794C120.379 133.931 129.873 124.831 138.166 114.715C138.748 114.006 139.33 113.285 139.888 112.57C147.455 122.061 156.577 130.261 166.868 136.772L166.862 136.766Z",
    fill: "url(#paint6_linear_1394_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.16 103.149C133.16 103.149 133.132 103.104 133.115 103.081C133.12 103.081 133.12 103.076 133.12 103.064C133.126 103.092 133.149 103.115 133.16 103.144V103.149Z",
    fill: "url(#paint7_linear_1394_74)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.278 101.945C334.303 104.209 330.839 106.141 326.865 107.718C322.89 109.294 318.472 110.093 313.609 110.093C310.168 110.093 307.037 109.472 304.195 108.25C301.353 107.029 299.111 105.209 297.424 102.766C296.003 100.679 295.203 98.2147 295.003 95.3505C297.468 96.4607 299.955 97.4598 302.441 98.3035C306.46 99.6579 311.212 100.324 316.718 100.324C321.314 100.324 325.643 99.5913 329.707 98.1481C333.747 96.7049 337.056 94.5512 339.587 91.6427C342.096 88.7563 343.361 84.9152 343.361 80.6523C343.361 76.3893 342.074 72.7259 339.498 69.6175C336.945 66.4869 333.392 64.0889 328.885 62.4237C324.378 60.7585 319.138 59.9148 313.188 59.9148C308.214 59.9148 303.485 60.7363 298.978 62.3571C294.471 63.9779 290.43 66.3092 286.877 69.351C283.303 72.3706 280.483 76.0119 278.418 80.2526C276.353 84.5155 275.31 89.2891 275.31 94.64C275.31 99.9909 276.331 104.654 278.418 108.739C280.483 112.802 283.325 116.199 286.944 118.974C290.541 121.728 294.582 123.815 299.044 125.213C303.507 126.612 308.081 127.3 312.766 127.3H312.788C317.406 127.3 321.669 126.812 325.643 125.813C329.618 124.836 333.259 123.437 336.612 121.616C339.942 119.818 342.962 117.731 345.67 115.378L337.278 101.945ZM301.154 80.9187C303.041 79.2979 305.172 78.0323 307.504 77.122C309.857 76.2339 312.388 75.7676 314.808 75.7676C317.229 75.7676 319.205 76.2339 320.648 77.122C322.091 78.0323 322.801 79.2091 322.801 80.6523C322.801 81.829 322.38 82.8725 321.514 83.7828C320.648 84.6932 319.404 85.3815 317.717 85.8921C316.052 86.3806 313.965 86.6692 311.434 86.7581C308.991 86.7581 306.127 86.4916 302.841 85.9587C301.353 85.7145 299.666 85.2704 297.823 84.6266C298.756 83.2722 299.866 82.0288 301.154 80.9187Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M429.072 91.5095V125.413H408.489V91.5095C408.489 89.7998 408.222 88.179 407.69 86.6914C407.135 85.2038 406.357 83.8939 405.314 82.7615C404.27 81.6292 403.027 80.7411 401.539 80.1194C400.052 79.4977 398.364 79.1647 396.455 79.1647C394.301 79.1647 392.125 79.6309 389.972 80.5413C387.796 81.4294 385.62 82.8059 383.4 84.671C381.246 86.5138 379.026 88.7341 376.828 91.3762V125.413H356.268V61.5356H376.828V75.8342C377.427 75.1459 378.027 74.4577 378.604 73.8138C381.401 70.7054 384.132 68.1076 386.797 66.0206C389.439 63.9335 392.192 62.4015 395.034 61.4024C397.876 60.4255 400.918 59.9148 404.182 59.9148C408.245 59.9148 411.819 60.5809 414.928 61.8908C418.036 63.2008 420.635 65.1991 422.722 67.8412C424.787 70.5278 426.363 73.8138 427.451 77.7437C428.539 81.6736 429.072 86.2696 429.072 91.5095Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M465.596 61.5386H445.036V125.416H465.596V61.5386Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M467.347 41.1985C467.347 44.1737 466.104 46.6604 463.639 48.6587C461.153 50.6347 457.933 51.6338 453.959 51.6338C450.34 51.6338 447.254 50.6569 444.678 48.6587C442.125 46.6604 440.837 44.1737 440.837 41.1985C440.837 38.0235 442.125 35.4257 444.678 33.3831C447.254 31.3626 450.34 30.3413 453.959 30.3413C457.933 30.3413 461.153 31.3626 463.639 33.3831C466.104 35.4257 467.347 38.0235 467.347 41.1985Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M538.797 101.945C535.822 104.209 532.336 106.141 528.362 107.718C524.41 109.294 519.992 110.093 515.107 110.093C511.688 110.093 508.557 109.472 505.715 108.25C502.873 107.029 500.609 105.209 498.943 102.766C497.522 100.679 496.701 98.2147 496.501 95.3505C498.988 96.4607 501.474 97.4598 503.961 98.3035C507.958 99.6579 512.731 100.324 518.238 100.324C522.834 100.324 527.141 99.5913 531.204 98.1481C535.267 96.7049 538.553 94.5512 541.084 91.6427C543.615 88.7563 544.881 84.9152 544.881 80.6523C544.881 76.3893 543.593 72.7259 541.018 69.6175C538.442 66.4869 534.912 64.0889 530.383 62.4237C525.875 60.7585 520.658 59.9148 514.707 59.9148C509.734 59.9148 505.005 60.7363 500.498 62.3571C495.99 63.9779 491.949 66.3092 488.375 69.351C484.822 72.3706 482.003 76.0119 479.916 80.2526C477.851 84.5155 476.807 89.2891 476.807 94.64C476.807 99.9909 477.851 104.654 479.916 108.739C482.003 112.802 484.845 116.199 488.441 118.974C492.06 121.728 496.079 123.815 500.564 125.213C505.027 126.612 509.601 127.3 514.286 127.3H514.308C518.904 127.3 523.189 126.812 527.163 125.813C531.115 124.836 534.779 123.437 538.109 121.616C541.44 119.818 544.481 117.731 547.19 115.378L538.797 101.945ZM502.673 80.9187C504.561 79.2979 506.67 78.0323 509.023 77.122C511.377 76.2339 513.886 75.7676 516.328 75.7676C518.77 75.7676 520.702 76.2339 522.145 77.122C523.589 78.0323 524.321 79.2091 524.321 80.6523C524.321 81.829 523.877 82.8725 523.033 83.7828C522.168 84.6932 520.902 85.3815 519.237 85.8921C517.572 86.3806 515.484 86.6692 512.953 86.7581C510.511 86.7581 507.647 86.4916 504.361 85.9587C502.851 85.7145 501.186 85.2704 499.321 84.6266C500.253 83.2722 501.386 82.0288 502.673 80.9187Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.852 93.3121L275.273 125.417H249.362L236.24 109.054L223.118 125.417H197.186L223.607 93.3121L197.186 60.4963H223.074L236.24 77.3927L249.407 60.4963H275.273L248.852 93.3121Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1394_74",
    x1: 37.7563,
    y1: 170.313,
    x2: 158.501,
    y2: 85.4072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC4375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1394_74",
    x1: 37.7563,
    y1: 170.313,
    x2: 158.501,
    y2: 85.4072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC4375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1394_74",
    x1: 37.7563,
    y1: 170.313,
    x2: 158.501,
    y2: 85.4072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC4375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1394_74",
    x1: 37.7563,
    y1: 170.313,
    x2: 158.501,
    y2: 85.4072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC4375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1394_74",
    x1: -22.838,
    y1: 171.412,
    x2: 202.369,
    y2: 3.95169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.130313,
    stopColor: "#A6EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898167,
    stopColor: "#DC4375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1394_74",
    x1: -22.9692,
    y1: 95.9491,
    x2: 134.803,
    y2: -15.0014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1394_74",
    x1: 59.9916,
    y1: 213.931,
    x2: 217.764,
    y2: 102.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1394_74",
    x1: 37.7563,
    y1: 170.313,
    x2: 158.501,
    y2: 85.4072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC4375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1394_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166.667,
    height: 166.667,
    fill: "white",
    transform: "translate(0.918823 17.1667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXenieNewLogo);
export default __webpack_public_path__ + "static/media/XenieNewLogo.2f455adff5bc7ced0d5217b0eef91c33.svg";
export { ForwardRef as ReactComponent };